




























import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import { VbDirectives } from '@/shared/directive/vb-directives';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';

@Component({
  filters: {
    toCurrency: VbDirectives.toCurrency,
  },
  components: {
    VbTooltipSlot,
  },
})
export default class OverviewMainCardTable extends Vue {
  @Prop({
    required: true,
  })
  private value!: number;

  @Prop({
    required: true,
  })
  private description!: string;

  @Prop({
    required: true,
  })
  private type!: string;

  @Prop({
    required: false,
    default: false,
  })
  private child!: boolean;

  @Prop({
    required: false,
    default: '0px',
  })
  private paddingLeft!: string;

  @Prop({
    required: false,
    default: '12px',
  })
  private fontSize!: string;

  @Emit('goToView')
  private goToView(status: string): string {
    return status;
  }

  private get valueColumn(): object {
    return {
      text: 'VALOR R$',
      align: 'right',
      value: 'value',
      width: '33%',
      sortable: false,
    }
  }

  private statusColor(value: string): string {
    switch (value) {
      case 'TO_BILL':
      case 'TO_RECEIVE':
        return '#DCB02A';
      case 'BILLED':
        return '#2F80ED';
      case 'RECEIVED':
      case 'ACTIVE':
        return '#189F51';
      case 'DEFAULTING':
      case 'INACTIVE':
      case 'INACTIVE_WITH_ACTIVE_INSTANCES':
      case 'INACTIVE_WITH_INACTIVE_INSTANCES_AND_CONSUMPTION':
      case 'INACTIVE_ON_COMPETENCE':
      case 'CANCELED':
      case 'CANCELED_WITH_ACTIVE_INSTANCES':
      case 'CANCELED_WITH_INACTIVE_INSTANCES_AND_CONSUMPTION':
      case 'CANCELED_ON_COMPETENCE':
        return '#FF3306';
      default:
        return 'black';
    }
  }

  getTooltipDescription(description: string, type: string) {
    const tip = {
      'Faturamento desabilitado': 'Contratos que estão ativos mas com faturamento desabilitado',
      Negociação: 'Faturamento desabilitado por motivo de negociação',
      'Faturamento Manual': 'Faturamento desabilitado por motivo de estar sendo faturado manualmente',
      'Aguardando Liberação da Unidade': 'Faturamento desabilitado pela unidade',
      'Em Implantação': 'Faturamento desabilitado devido ao cliente ainda estar em implantação',
      Inconsistentes: 'Contratos que estão ativos mas com inconsistência',
      Cancelamento: 'Faturamento desabilitado devido ao contrato estar cancelado',
      Prévias: 'Inconsistência por motivo de prévia',
      'Falta de Data de Início': 'Inconsistência por motivo de falta de início de faturamento',
      'Falta de Instância': 'Inconsistência por motivo de falta de instância',
      'Falta de Cálculo': 'Inconsistência por motivo de falta de cálculo',
      'Com instâncias inativas e com consumo': 'Contratos que estão cancelados e com instâncias inativas mas com consumo',
      'Sem PO Cadastrada/Expirada': 'Inconsistência por motivo de falta de PO',
    }
    if (tip[description] == null) {
      const tipWithType = {
        ACTIVE_WITH_EXPIRE_IN: 'Contratos ativos com previsão de encerramento na competência de',
        INACTIVE_WITH_ACTIVE_INSTANCES: 'Contratos que estão inativos mas com instâncias ativas',
        INACTIVE_WITH_INACTIVE_INSTANCES_AND_CONSUMPTION: 'Contratos e instâncias inativas mas com instâncias com consumo na competência',
        INACTIVE_ON_COMPETENCE: 'Contratos que estão inativos na competência',
        INACTIVE_WITH_EXPIRE_IN: 'Contratos inativos com previsão de encerramento na competência',
        CANCELED_WITH_ACTIVE_INSTANCES: 'Contratos que estão cancelados e com instâncias ativas',
        CANCELED_ON_COMPETENCE: 'Contratos que estão cancelados na competência',
        ACTIVE_WITH_CONSUMPTION: 'Instâncias ativas e com consumo',
        ACTIVE_WITHOUT_CONSUMPTION: 'Instâncias ativas e sem consumo',
        INACTIVE_WITH_CONSUMPTION: 'Instâncias inativas e com consumo',
        INACTIVE_WITHOUT_CONSUMPTION: 'Instâncias inativas e sem consumo',
        UNBOUND_CONTRACT_WITH_CONSUMPTION: 'Instâncias sem vínculo com contrato e com consumo',
        UNBOUND_CONTRACT_WITHOUT_CONSUMPTION: 'Instâncias sem vínculo com contrato e sem consumo',
      }
      if (tipWithType[type] == null) {
        return description
      }
      return tipWithType[type];
    }
    return tip[description];
  }
}
